"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(reducerManagerId, reducer, initialState) {
  return function () {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    if (action && action.reducerManagerId === reducerManagerId) {
      return reducer(state, action);
    }
    return state;
  };
};